import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripLinesVertical, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import Sidebar from './Sidebar';
import { AuthProvider } from '../utils/AuthContext';
import '../style/layout.css';


// Layout component
function Layout(props) {
  // Access the history object to navigate between routes
  const history = useHistory();
  // User state to hold user data
  const [user, setUser] = useState(null);

  // State to manage the visibility of the sidebar
  // Sur mobile (< 992px), la sidebar est cachée par défaut
  // Sur desktop, elle est visible et non minimisée
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth >= 992);
  const [sidebarMinimized, setSidebarMinimized] = useState(false);

  // Function to toggle the visibility/minimization of the sidebar
  const toggleSidebar = () => {
    const isDesktop = window.innerWidth >= 992;

    if (isDesktop) {
      // Sur desktop, on toggle entre minimisé et déplié
      setSidebarMinimized(!sidebarMinimized);
    } else {
      // Sur mobile, on toggle entre caché et visible
      setSidebarVisible(!sidebarVisible);
    }
  };
   // Redirect to the login page if there is no authToken
  const token = localStorage.getItem('authToken')


  // useEffect to check authentication status on component mount
  useEffect(() => {
    if (!token) {
      history.push('/login'); // Change '/login' to the desired login route
      return null; // Render nothing for now, as the user will be redirected
    }
    // Extracting user data in local storage
    const userDataString = localStorage.getItem('userData');
    const userData = userDataString ? JSON.parse(userDataString) : null;
    setUser(userData);
  }, [token,history]);

  // Render the component
  return (
    <AuthProvider>
      {/* Bouton hamburger pour mobile */}
      <button
        className={`hamburger-btn ${sidebarVisible ? 'hidden' : ''}`}
        onClick={toggleSidebar}
        aria-label="Ouvrir le menu"
      >
        <FontAwesomeIcon icon={faBars} size="lg" />
      </button>

      {/* Overlay backdrop pour mobile */}
      {sidebarVisible && (
        <div
          className="sidebar-overlay"
          onClick={toggleSidebar}
        />
      )}

      <Container fluid>
        <Row>
          {/* Sidebar */}
          <Col
            xs={9}
            md={3}
            lg={2}
            className={`sidebar ${sidebarVisible ? 'active' : ''} ${sidebarMinimized ? 'minimized' : ''}`}
          >
            {/* Bouton fermer pour mobile dans la sidebar */}
            <button
              className="close-sidebar-btn"
              onClick={toggleSidebar}
              aria-label="Fermer le menu"
            >
              <FontAwesomeIcon icon={faTimes} size="lg" />
            </button>

            <Sidebar user={user} minimized={sidebarMinimized} />
            {/* Button to toggle the sidebar (desktop) */}
            <a onClick={toggleSidebar} className="toggle-btn d-none d-lg-block" href='#toogle'>
              <FontAwesomeIcon icon={faGripLinesVertical} size='1x' />
            </a>
          </Col>

          {/* Main content area */}
          <Col className={`main-content ${sidebarVisible ? 'active' : ''} ${sidebarMinimized ? 'minimized' : ''} mainBgColor vh-100`}>
            {/* Render child components */}
            {props.children}
          </Col>
        </Row>
      </Container>
    </AuthProvider>
  );
}

export default Layout;
